import { ContentState } from 'draft-js'
import React from 'react'

import InlineLink from '../inline-link'

type Props = {
  children: React.ReactNode
  contentState: ContentState
  entityKey: string
}

const Link = ({
  children,
  contentState,
  entityKey,
}: Props): React.ReactElement<'a'> => {
  const { url } = contentState.getEntity(entityKey).getData()
  return <InlineLink to={url}>{children}</InlineLink>
}

export default Link
